const pagesIndividualDevicesEn = {
  headers: {
    assetTag: 'Asset Tag',
    assignee: 'Assigned To',
    deviceTag: 'Device Tag',
    genre: 'Type',
    model: 'Model',
    name: 'Device',
    status: 'Status'
  },
  pageTitle: 'Devices',
  tabs: {
    managedPlace: 'My Oversight Places',
    self: 'My Devices'
  }
};
export default pagesIndividualDevicesEn;